/*
 * Authors: Koen, mariushirjanu
 * Created: 17/10/2020
 * Upgraded: 24/11/2023
 */
import { Injectable } from '@angular/core';

export const STORAGE_LOGGER_PAYLOAD:string = 'ga2.logger.payload';

@Injectable()
export class MemoryStorageService {
  private storage:any[] = [];

  public set(key:string, item:any):void {
    this.storage[key] = item;
  }

  public get(key:string):any {
    return this.storage[key];
  }

  public remove(key:string):void {
    delete(this.storage[key]);
  }

  public clear():void {
    this.storage = [];
  }
}